<template>
  <div class="base-box">
    <van-field class="input-item" v-model="params.mobile" label="手机号" placeholder="请输入您的手机号码"></van-field>
    <van-field class="input-item" v-model="params.captcha" label="图片验证" clearable placeholder="请输入图片验证码">
      <div slot="button" @click="changeCode()">
        <img v-if="captchaImage" :src="captchaImage" class="chaImage" />
      </div>
    </van-field>
    <van-field class="input-item" v-model="params.code" label="验证码" clearable placeholder="请输入短信验证码">
      <van-button :disabled="isDisabled" slot="button" plain size="small" type="primary" @click="getCode">
        <template v-if="!isSpend">获取验证码</template>
        <template v-else>( {{time+'s后重新获取'}} )</template>
      </van-button>
    </van-field>
    <van-field class="input-item" v-model="params.name" label="姓名" placeholder="请输入您的姓名"></van-field>
    <van-button class="successedBtn" type="primary" block @click="next">完成</van-button>
    <!-- <van-checkbox
      class="rule-box"
      checked-color="#1989fa"
      v-model="checked"
      icon-size="16px"
    >
      我已阅读
      <span @click.stop="goHerf">《入会须知》</span>
    </van-checkbox> -->
  </div>
</template>

<script>
  import { Field, Button, Checkbox, Toast, Popup, Cell, CellGroup, Picker, Divider } from "vant";
  import { fastRegisterMember, getRegisterCode, getMobileLoginCode, verifyRegisterCode, checkMobile, getCaptchaImage } from "@/api/login";
  import { getUser } from "@/api/dictionary";
  import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
  import { setSessionStore } from "@/utils/sessionStorage";
  export default {
    data() {
      return {
        time: 60,
        isSpend: false,
        isDisabled: false,
        params: {
          mobile: "",
          code: "",
          name: "",
        },
        checked: false,
        isShowPW: true,
        isShowPW2: true,
        beginClientX: 0 /*距离屏幕左端距离*/,
        mouseMoveStata: false /*触发拖动状态  判断*/,
        maxwidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/,
        confirmWords: "请按住滑块，拖到最右边" /*滑块文字*/,
        confirmSuccess: false /*验证成功判断*/,
        selectModel: false,
        memberName: "",
        key: "",
        columns: [],
        value: 0,
        captchaImage: null,
      };
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Popup.name]: Popup,
      [Cell.name]: Cell,
      [Picker.name]: Picker,
      [CellGroup.name]: CellGroup,
      [Divider.name]: Divider
    },
    computed: {
      meetingId() {
        return this.$route.query && this.$route.query.meetingId
      },
      sourc() {
        return this.$route.query && this.$route.query.sourc
      },
      ...mapState(["memberTypeList"]),
    },
    created() {
      this.getCaptchaImageFunction()
    },
    methods: {
      ...mapActions(["securityCheck"]),
      ...mapMutations(["setMemberInfo"]),
      changeCode() {
        this.getCaptchaImageFunction()
      },
      getCaptchaImageFunction() {
        let captchaUuid = "";
        if (sessionStorage.getItem("captchaUuid")) {
          captchaUuid = sessionStorage.getItem("captchaUuid");
        } else {
          //生成captchaUuid
          let times = new Date().getTime();
          let numNo = Number(Math.random().toString().substr(2));
          captchaUuid = (times + numNo).toString(12);
          sessionStorage.setItem("captchaUuid", captchaUuid);
        }
        getCaptchaImage({ captchaUuid: captchaUuid }).then(res => {
          if (res.success) {
            this.$set(this, "captchaImage", res.result)
          } else {
            this.$message.error(res.message || "验证码生成失败");
          }
        })
      },
      register() {
        let params = {
          mobile: this.params.mobile,
          code: this.params.code
        }
        verifyRegisterCode(params).then(res => {
          if (res.success) {
            let params = this.params;
            params.password = this.params.mobile + "@86#";
            params.password2 = this.params.mobile + "@86#";
            params.memberCategory = 1;
            params.memberType = 9;
            fastRegisterMember(params).then((res) => {
              if (res.success) {
                this.submit();
              } else {
                if (res.messageCode == "110001") {
                  Toast.fail("手机号码已经注册");
                  return;
                }
                if (res.messageCode == "110002") {
                  Toast.fail("手机号码已经注册");
                  return;
                }
                Toast.fail("注册失败!");
              }
            });
          } else {
            Toast("验证码不正确！");
          }
        });
      },
      submit() {

        var params = {
          username: this.params.mobile,
          password: this.params.mobile + "@86#",
          memberCategory: 1,
          userType: 1,
          grant_type: "password",
          scope: "server",
          client_id: "mms_meeting",
          client_secret: 123456,
        };
        this.securityCheck(params)
          .then((res) => {
            this.getUserInfo()
              .then((res) => {
                // if (this.meetingId) {
                //   this.$router.push({ name: "personalRegistration", query: { id: this.meetingId, sourc: this.sourc } });
                // } else {
                this.$router.push({ name: "MeetingList" });
                // }
              })
              .catch(() => {
                Toast.fail("用户信息获取失败");
              });
          })
          .catch((res) => {
            Toast.fail("登录失败");
          });
      },
      getUserInfo() {
        return new Promise((resolve) => {
          getUser().then((res) => {
            if (res.success) {
              this.userInfo = res.result;
              window.localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
              this.setMemberInfo(res.result);
              setSessionStore("memberId", res.result.id);
              resolve();
            } else {
              Toast("用户信息获取失败");
            }
          });
        });
      },
      goHerf() {
        this.$router.push({ path: "/rule" });
      },

      async next() {
        if (!this.params.mobile) {
          Toast("请输入手机号！");
          return;
        }
        if (!this.params.code) {
          Toast("请输入验证码！");
          return;
        }
        if (!this.params.name) {
          Toast("请输入真实姓名！");
          return;
        }

        this.register();
      },
      async getCode() {
        let mobile = this.params.mobile;
        if (this.isSpend || this.params.mobile === 0) {
          return;
        }
        if (!this.$regexp.mobile(mobile)) {
          Toast("请输入正确的手机号");
          return false;
        }
        if (!this.params.captcha) {
          Toast("请输入图片验证码");
          return false;
        }
        await this.checkMobiles(this.params.mobile);
        //生成签名
        let timestamp = new Date().getTime();
        let data = "appSecretKey=captcha_codes&mobile=" + mobile + "&timestamp=" + timestamp;
        let sign = this.$md5(data);
        getRegisterCode({
          mobile: mobile,
          captchaUuid: sessionStorage.getItem("captchaUuid"),
          captcha: this.params.captcha, sign: sign, timestamp: timestamp
        }).then((res) => {
          if (res.success) {
            this.isSpend = true;
            this.time = 60;
            this.count();
          } else {
            Toast(res.message);
          }
        });
      },
      checkMobiles(mobile) {
        let params = {
          mobile,
          userType: 1
        };
        return new Promise((resolve, reject) => {
          checkMobile(params)
            .then(res => {
              if (!res.result && res.success) {
                resolve();
              } else {
                Toast("该手机号码已经注册过！");
              }
            })
            .catch(() => {
              Toast("该手机号码已经注册过！");
            });
        });
      },
      count() {
        --this.time;
        if (this.time > 0) {
          setTimeout(() => {
            this.count();
          }, 1000);
        } else {
          this.isSpend = false;
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .successedBtn {
    margin: 30px 0 25px 0 !important;
  }

  .rule-box {
    justify-content: center;
    margin-bottom: 20px;
  }

  /deep/ .van-field__label {
    width: 2.2rem;
  }

  /deep/.van-cell__value {
    width: 80%;
  }

  /deep/.van-cell__value {
    padding-left: 0;
    padding-right: 0;
  }

  .input-item {
    padding: 0;
    padding-bottom: 0.32rem;
    display: flex;
    align-items: center;
  }

  .input-item+.input-item {
    margin-top: 0.53333rem;
  }

  .chaImage {
    width: 90px;
    height: 30px;
    margin-left: 10px
  }
</style>